// because server does not support time zones and return date in utc
export const normalizeTaskDueDate = (dueDate: string) => {
  return dueDate.endsWith('+00:00') ? dueDate : dueDate + '+00:00';
};
